// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import GridPage from "../components/GridPage";
import { useLocation } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import { doctorAppoinmentsHeaders } from "../components/HeaderAttribute";
import { BindPostAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Loader from "../ReusableComponents/Loader";

const DoctorAppointments = () => {
  const location1 = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  //All visible functionality useState hooks handling.
  const [isLoading, setIsLoading] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);

  useEffect(() => {
    BindGridData();
    if (location1.pathname == "/doctorappointments") {
      setVisibleTable(true);
    }
  }, [location1, userProfileDatas]);

  const BindGridData = async () => {
    debugger
    if (userProfileDatas && userProfileDatas[0]) {
      try {
        setIsLoading(true);
        const payload = {
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstBranchId: userProfileDatas[0].MstLocationId,
          mstSdpId: userProfileDatas[0].MstSDPId
            ? userProfileDatas[0].MstSDPId
            : 0,
          mstUserId: userProfileDatas[0].MstUserId,
          mstRoleId: userProfileDatas[0].MstRoleId,
        };
        const response = await BindPostAPI(
          payload,
          "DoctorConsultation/BindDoctorConsultation"
        );
        setBindAppoinmentsDatas(response.data.Table);
      } catch (error) {
        console.error("Error loading doctor appointments:", error);
      } finally {
        setIsLoading(false); // loader stop (success/error both cases)
      }
    }
  };

  const [bindAppointmentsDatas, setBindAppoinmentsDatas] = useState([]);

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Doctor Consultation"}
          xScroll="overflow-x-auto max-md:w-fit w-full"
          tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-gray-500 w-full md:min-w-fit"
          header={doctorAppoinmentsHeaders}
          records={bindAppointmentsDatas}
          addView={true}
        />
      )}
    </MainLayout>
  );
};

export default DoctorAppointments;
